module.exports = __webpack_public_path__ + "static/media/BGP-SWPSeries.fec1c81e.pdf";